import React from 'react';
import { useTranslation } from 'react-i18next';
import { ModalContent, ModalFooter } from 'fronton-react';
import { ButtonWithGAClickButton, ModalHeader, Typography } from 'common/components';
import { css } from 'linaria';
import {
  BATHROOM_REPAIR_ELEMENT_BLOCK,
  BATHROOM_REPAIR_SIGN_UP_HREF,
} from '../../../../bathroom-repair-constants';

const modalText = css`
  &:not(:last-of-type) {
    margin-bottom: 8px;
  }
`;

type OneMonthProps = {
  regionId: string;
};

export const OneMonthModal = ({ regionId }: OneMonthProps) => {
  const { t } = useTranslation();

  return (
    <>
      <ModalHeader title={t('utp-section.one-month.modal-title')} />
      <ModalContent>
        <Typography variant="m" size="body_long" className={modalText}>
          {t('utp-section.one-month.modal-description-first')}
        </Typography>
        <Typography variant="m" size="body_long" className={modalText}>
          {t('utp-section.one-month.modal-description-second')}
        </Typography>
      </ModalContent>
      <ModalFooter>
        <ButtonWithGAClickButton
          adaptive={false}
          elementBlock={BATHROOM_REPAIR_ELEMENT_BLOCK}
          elementName={`${t('utp-section.one-month.modal-title')} / modal`}
          elementText={t('utp-section.modal-button')}
          href={`${BATHROOM_REPAIR_SIGN_UP_HREF}${regionId}`}
          target="_blank"
          wide>
          {t('utp-section.modal-button')}
        </ButtonWithGAClickButton>
      </ModalFooter>
    </>
  );
};
